<template>
	<section>
		<header>
			<div class="logo-or-hamburger-container">
				<div class="hamburger">
					<div class="hamburger-icon">
						<a href @click.prevent="toggleMenu" class="hamburger-icon__checkbox" :class="{ active: menuOpen }" />
						<div>
							<span></span>
							<span></span>
							<span></span>
						</div>
					</div>
				</div>
				<router-link to="/dashboard" class="icon"><span v-if="!currentAccount.icon" class="fak fa-gravity-fox"></span><img v-else :src="currentAccount.icon" :alt="currentAccount.company"></router-link>
			</div>
			<div class="links">
				<div class="link"><router-link v-if="currentAccount.id && canManageUsers" to="/account/users/overview"><span class="fa fa-user-friends rotate-45-left-to-right"></span><div class="hover-title">Users</div></router-link></div>
				<div class="link"><router-link to="/settings/tokens" exact><span class="fa fa-key-skeleton"></span><div class="hover-title">API Keys</div></router-link></div>
				<div class="link"><router-link to="/settings/profile"><span class="fa fa-id-card"></span><div class="hover-title">Profile</div></router-link></div>
				<div class="link"><router-link v-if="currentAccount.id && canManageLog" to="/activity-log"><span class="fa fa-book"></span><div class="hover-title">Activity</div></router-link></div>
				<div class="link"><router-link v-if="$root.isSuperAdmin" :to="`/admin/accounts/${ currentAccount.id }/modules`"><span class="fa fa-hammer"></span><div class="hover-title">Modules</div></router-link></div>
				<div class="link"><router-link v-if="$root.isSuperAdmin" to="/settings/ux" exact><span class="fa fa-palette"></span><div class="hover-title">Design</div></router-link></div>
				<div class="link"><a href @click.prevent="logout"><span class="fa fa-sign-out"></span><div class="hover-title">Log Out</div></a></div>
				<div class="lightswitch">
					<div class="toggle-button" id="lightswitch">
						<div class="hover-title">Choose Theme</div>
						<input type="checkbox" v-model="form.theme" value="1">
						<span></span>
					</div>
				</div>
			</div>
		</header>
		<module-nav v-if="!currentAccount.master"></module-nav>
		<super-admin-nav v-if="currentAccount.master"></super-admin-nav>
	</section>
</template>

<script>

import ModuleNav from './secondary/ModuleNav';
import { ACCESS_TYPE } from '@/constants/connections';

import { mapGetters, mapState } from 'vuex';

export default {

	computed: {

		...mapGetters([ 'accounts', 'canManageBilling', 'currentAccount' ]),

		...mapState({
			theme: state => state.layout.theme,
			menuOpen: state => state.layout.menuOpen,
		}),

		canManageUsers() {
			return this.hasAdminAccess || this.currentAccount.access.can_manage_users;
		},

		canManageLog() {
			return this.hasAdminAccess || this.currentAccount.access.access_type === ACCESS_TYPE.FULL;
		},

		permissions() {
			return this.currentAccount.access.access_type !== ACCESS_TYPE.BASIC ? [] : (this.currentAccount.access.access_permissions || '').split(',').filter(value => !!value);
		},

		hasAdminAccess() {
			return this.currentAccount.access.access_type === ACCESS_TYPE.ADMIN;
		},

	},

	mounted() {
		this.$set(this.form, 'theme', this.theme === 'dark' ? 1 : 0);
	},

	methods: {

		openMenu() {
			this.$store.dispatch('openMenu');
		},

		closeMenu() {
			this.$store.dispatch('closeMenu');
		},

		toggleMenu(e) {
			e.stopPropagation();
			if (this.menuOpen) {
				this.closeMenu();
			} else {
				this.openMenu();
			}
		},

		async logout() {
			await this.$store.dispatch('logout');
			this.$router.push('/login');
		},

	},

	watch: {
		'$route': function() {
			this.$store.dispatch('closeMenu');
		},
		'form.theme': function(newValue) {
			const theme = newValue ? 'dark' : 'light';
			this.$api.post('/user', { theme });
			this.$store.dispatch('updateTheme', { theme, store: true });
		},
		theme(newValue) {
			this.$set(this.form, 'theme', newValue === 'dark' ? 1 : 0);
		},
	},

	components: {
		ModuleNav,
	},

	data() {
		return {
			form: {
				theme: 1,
			},
		};
	},

};

</script>
